<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-main">
        <div class="footer-logo">
          <img src="../assets/logo.png" alt="Logo" class="footer-logo-img" />
          <div class="footer-logo-text">Photo Enhancer</div>
        </div>
        
        <div class="footer-links">
          <div class="footer-section">
            <h3>Products</h3>
            <ul>
              <li><a href="#">Features</a></li>
              <li><a href="#">Pricing</a></li>
              <li><a href="#">Download App</a></li>
            </ul>
          </div>
          
          <div class="footer-section">
            <h3>Support</h3>
            <ul>
              <li><a href="#">Help Center</a></li>
              <li><a href="mailto:yikenxinxin@gmail.com">Contact Us</a></li>
              <li><a href="#">FAQ</a></li>
            </ul>
          </div>
          
          <div class="footer-section social-section">
            <h3>Follow Us</h3>
            <div class="social-links">
              <a href="#" class="social-icon"><span>📱</span></a>
              <a href="#" class="social-icon"><span>💬</span></a>
              <a href="#" class="social-icon"><span>📷</span></a>
            </div>
          </div>
        </div>
      </div>
      
      <div class="footer-bottom">
        <div class="copyright">
          Copyright &copy; 2024 markwatermark.com All rights reserved
        </div>
        <div class="legal-links">
          <a href="#">Privacy Policy</a>
          <a href="#">Terms of Use</a>
          <a href="#">Cookie Settings</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent'
}
</script>

<style scoped>
.footer {
  background-color: #1a1a2e;
  padding: 60px 0 30px;
  color: #fff;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-main {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 40px;
}

.footer-logo {
  display: flex;
  align-items: center;
  margin-right: 100px;
  margin-bottom: 20px;
}

.footer-logo-img {
  width: 40px;
  height: 40px;
  margin-right: 10px;
  background-color: white;
  border-radius: 5px;
  padding: 3px;
}

.footer-logo-text {
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.footer-links {
  display: flex;
  flex: 1;
  justify-content: space-between;
  flex-wrap: wrap;
}

.footer-section {
  margin-right: 30px;
  margin-bottom: 20px;
  min-width: 120px;
}

.footer-section h3 {
  font-size: 16px;
  margin-bottom: 15px;
  color: #4a6bff;
  font-weight: 600;
}

.footer-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-section li {
  margin-bottom: 10px;
}

.footer-section a {
  color: #b0b0cc;
  text-decoration: none;
  transition: color 0.2s;
  font-size: 14px;
}

.footer-section a:hover {
  color: white;
}

.social-links {
  display: flex;
  gap: 12px;
}

.social-icon {
  width: 36px;
  height: 36px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  transition: all 0.3s;
  display: inline-block;
  text-align: center;
}

.social-icon span {
  font-size: 18px;
  line-height: 34px; /* 略微减小，让图标稍微上移 */
  display: inline-block;
}

.social-icon:hover {
  background-color: #4a6bff;
  transform: translateY(-3px);
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  flex-wrap: wrap;
}

.copyright {
  color: #b0b0cc;
  font-size: 14px;
  margin-bottom: 10px;
}

.legal-links {
  display: flex;
  gap: 20px;
}

.legal-links a {
  color: #b0b0cc;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.2s;
}

.legal-links a:hover {
  color: white;
}

/* Mobile optimization */
@media (max-width: 768px) {
  .footer {
    padding: 40px 0 80px;
  }
  
  .footer-content {
    padding: 0 24px;
  }
  
  .footer-main {
    flex-direction: column;
  }
  
  .footer-logo {
    margin-right: 0;
    margin-bottom: 30px;
    justify-content: center;
  }
  
  .footer-links {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
    width: 100%;
  }
  
  .footer-section {
    margin-right: 0;
    margin-bottom: 0;
    min-width: 0;
  }
  
  .social-section {
    grid-column: span 2;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    text-align: center;
  }
  
  .footer-section li {
    margin-bottom: 16px;
  }
  
  .footer-section a {
    font-size: 16px;
    display: block;
    padding: 4px 0;
  }
  
  .social-links {
    justify-content: center;
    margin-top: 20px;
    width: 100%;
  }
  
  .social-icon {
    width: 48px;
    height: 48px;
    margin: 0 8px;
  }
  
  .social-icon span {
    font-size: 20px;
    line-height: 46px; /* 略微减小，让图标稍微上移 */
  }
  
  .footer-bottom {
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-top: 40px;
  }
  
  .copyright {
    margin-bottom: 20px;
    font-size: 13px;
  }
  
  .legal-links {
    justify-content: center;
    flex-wrap: wrap;
    row-gap: 12px;
  }
  
  .legal-links a {
    padding: 5px 0;
  }
}

/* Small mobile screens */
@media (max-width: 480px) {
  .footer-links {
    grid-template-columns: 1fr;
  }
  
  .footer-section {
    text-align: center;
  }
  
  .social-section {
    grid-column: 1;
    margin-top: 30px;
  }
}
</style> 